import { OpenAPI } from '../services';

export const getCurrentOrg = () => {
  const headers = OpenAPI.HEADERS;
  if (typeof headers !== 'object') return '';

  return headers['x-ai-agent-organization-context'];
};
